"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsSlider = void 0;
const icons_1 = require("@components/icons");
const _utils_1 = require("@utils");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const TabsSlider = (props) => {
    const { activeTabIndex, transfers, onSelect, removeTab } = props;
    return (react_1.default.createElement("div", { className: "c-tabs-slider" }, transfers.map((item, index) => (react_1.default.createElement("button", { onClick: () => onSelect(index), className: (0, classnames_1.default)("c-tabs-slider-button", { "c-tabs-slider-button-active": activeTabIndex === index }), key: crypto.randomUUID() },
        (0, _utils_1.formatAddress)(item),
        activeTabIndex === index && (react_1.default.createElement("div", { className: "c-tabs-slider-button-remove", onClick: () => removeTab(activeTabIndex) },
            react_1.default.createElement(icons_1.CrossIcon, { color: "white", hoverColor: "#60C392", scale: 0.7 }))))))));
};
exports.TabsSlider = TabsSlider;
